// extracted by mini-css-extract-plugin
export default {"container":"BirthdateField_container__mzB1s","item":"BirthdateField_item__9Yb49","label":"BirthdateField_label__1ROim"};